import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeamTypeLookupComponent } from './team-type-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [TeamTypeLookupComponent],
  exports: [TeamTypeLookupComponent]
})
export class TeamTypeLookupModule { }
